module.exports = __webpack_public_path__ + "static/img/hide-your-ip.44d017d8.svg";